import Card from "@material-ui/core/Card";
import { Theme, makeStyles } from "@material-ui/core/styles";
import Brightness3Icon from "@material-ui/icons/Brightness3";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import {
    changeAppState,
    getAppState,
    useAppState,
} from "../../../../common/appState";
import { spaceBetween } from "../../../../common/util/Array/spaceBetween";
import { darkModeClassNameAndKey } from "../../App";

export function DarkModeButton() {
    const [isDarkMode] = useAppState("isDarkMode");
    const c = useStyles({ isDarkMode });

    return (
        <Card
            className={c.card}
            onClick={() => {
                const newMode = !getAppState().isDarkMode;
                changeAppState("isDarkMode", newMode);
                localStorage.setItem(
                    darkModeClassNameAndKey,
                    newMode.toString()
                );
            }}
        >
            <Card className={spaceBetween(c.innerCard, "reverseDarkMode")}>
                {isDarkMode ? (
                    <WbSunnyIcon className={c.sunIcon} />
                ) : (
                    <Brightness3Icon className={c.moonIcon} />
                )}
            </Card>
        </Card>
    );
}
const useStyles = makeStyles<Theme, { isDarkMode: boolean | null }>({
    card: {
        position: "absolute",
        top: -35,
        height: 35,
        width: 35,
        right: 5,
        padding: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
    },
    innerCard: ({ isDarkMode }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: isDarkMode ? "white" : "black",
        height: 30,
        width: 30,
    }),
    moonIcon: {
        color: "yellow",
    },
    sunIcon: {
        color: "#eed105",
    },
});
